import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import Header from "@/components/header/Header";

type questionProps = {
  question: string;
  answer: string;
  anchor: string;
};

export default function TermsAndConditions() {
  const { hash } = useLocation();
  const { t } = useTranslation();
  const { t: tTermsAndConditions } = useTranslation("termsandconditions");

  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState<questionProps[]>([]);
  const [anchorSelected, setAnchorSelected] = useState<string | null>(null);

  const useScrollToLocation = () => {
    const scrolledRef = React.useRef(false);
    const hashRef = React.useRef(hash);

    React.useEffect(() => {
      if (hash) {
        const auxHash = hash.split("#")[1];
        setAnchorSelected(auxHash as string);

        if (hashRef.current !== hash) {
          hashRef.current = hash;
          scrolledRef.current = false;
        }

        if (!scrolledRef.current) {
          const id = hash.replace("#", "");
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
            scrolledRef.current = true;
          }
        }
      }
    }, []);
  };

  useEffect(() => {
    const termsandconditions = tTermsAndConditions(
      "termsandconditions",
      {
        returnObjects: true,
      }
    );

    if (termsandconditions) {
      setQuestions(Array.isArray(termsandconditions) ? termsandconditions : []);
    }

    setLoading(false);
  }, [hash, tTermsAndConditions]);

  useScrollToLocation();

  function changeAnchorSelected(newAnchor: string | null) {
    if (newAnchor === anchorSelected) {
      newAnchor = null;
    }

    setAnchorSelected(newAnchor);
  }

  return (
    <div className="flex flex-col gap-12 pb-2">
      <Header
        title={t("site_credentials.legal_advice")}
        showLoading={loading}
        previousStepBackXTimes={1}
      />
      {!loading && questions != null && questions.length > 0 && (
        <div className="faq-container mt-1">
          <Accordion type="single"
            collapsible
            defaultValue={anchorSelected ? anchorSelected : undefined}
            className="w-full">
            {questions.map((q, i) => (
              <AccordionItem id={q.anchor} value={q.anchor} variant={"container"}>
                <AccordionTrigger onClick={() => changeAnchorSelected(q.anchor)}>{q.question}</AccordionTrigger>
                <AccordionContent>
                  {q.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      )}
    </div>
  );
}
